import React, { Component } from "react";
import "./Game.css";
import openSocket from "socket.io-client";
import { Button, Image } from "react-bootstrap";
import io from "socket.io-client";
import { type } from "os";

export default class Bingo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bingoValues: [
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?",
        "?"
      ],
      num: [],
      btnHide: "static",
      mark: "none"
    };

    const socket = io("https://numbers.inspectron.ch/");
    const socket2 = io("https://numbers.inspectron.ch/numbers");

    socket.on("resetAll2", (data) => {
      this.setState({btnHide: "static" })
    })

    socket.emit("sendNums");
    socket.on("getNums", getNums => {
      this.setState({ bingoValues: getNums });

      const selectBox2  = async num => {
        await fetch("https://numbers.inspectron.ch/numbers")
          .then(result => result.json())
          .then(result => {
            this.setState({ num: result.numbers });
            num = result.numbers;
            console.log("num: " + this.state.num);
            var i;
            let num2 = this.state.num.map(Number);
            console.log("what is thsi" + this.state.bingoValues[1]);
            console.log(this.state.bingoValues);
            for (i = 0; i < this.state.num.length; i++) {
              if (this.state.bingoValues.includes(num2[i])) {
                document.getElementById([num2[i]]).style.backgroundColor =
                  "#FFD500";
              }
            }
          })
          
      };

      selectBox2(this.state.bingoValues);


    });

  }

  componentDidMount() {
    const socket = openSocket("https://numbers.inspectron.ch/");
    this.setState({
      test: 2,
  }, () => console.log(this.state.test));
    const bingo = this.state.bingoValues.map(String);

    function arrayContainsAnotherArray(num1, num2) {
      for (var i = 0; i < num1.length; i++) {
        if (num2.indexOf(num1[i]) === -1) return false;
      }
      return true;
    }

    if(localStorage.numbers) {
      this.setState({
        btnHide: "none"
      })
    }

    const bingoRow = () => {


      const row1 = [];
      const row2 = [];
      const row3 = [];
      const row4 = [];
      const row5 = [];

      row1.push(bingo[0], bingo[1], bingo[2], bingo[3], bingo[4]);
      row2.push(bingo[5], bingo[6], bingo[7], bingo[8], bingo[9]);
      row3.push(bingo[10], bingo[11], bingo[12], bingo[13], bingo[14]);
      row4.push(bingo[15], bingo[16], bingo[17], bingo[18], bingo[19]);
      row5.push(bingo[20], bingo[21], bingo[22], bingo[23], bingo[24]);

      console.log("bingooooooo " + bingo[0])
        console.log(arrayContainsAnotherArray(row1, this.state.num));
        console.log(this.state.num);
        console.log("hello"+ bingo);

 
    
    };

    // Socket Listens for Number and marks the specific Id with it.
    socket.on("number2", data => {
      console.log("hallo" + data);
      if (this.state.bingoValues.includes(data)) {
        let clock = setInterval(() => {
          clearInterval(clock);
          clock = null;
          // This isnt  React style (manually changing DOM) it works but should may be changed in future
          document.getElementById(data).style.backgroundColor = "#FFD500";
        }, 7000);
      }

      setTimeout(() => {
        bingoRow();
      }, 2000);

    });
    bingoRow();
  }
  render() {
    const socket = io("https://numbers.inspectron.ch/");
    if (localStorage.numbers) {
      var ls = JSON.parse(localStorage.numbers);
    }

    return (
      <div>
        <div className="flex-container">
          {this.props.data.map(i => (
            <div
              id={`${localStorage.numbers ? ls[i] : this.state.bingoValues[i]}`}
              key={i}
              className="flex-item"
            >
              {`${localStorage.numbers ? ls[i] : this.state.bingoValues[i]}`}
            </div>
          ))}
        </div>
        <div className="somDiv">
        <Image
        src="/assets/reload.png"
        className="ImgButtonL"
        style={{
          display: this.state.btnHide
        }}
          onClick={() => {
            socket.emit("sendNums");
            socket.on("getNums", getNums => {
              console.log(getNums);
              this.setState({ bingoValues: getNums });
              localStorage.setItem(
                "numbersCache",
                JSON.stringify(this.state.bingoValues)
              );
            });
          }}
        >
        </Image>
        <Image
          className="ringo-button"
          src="/assets/check-mark.png"
          style={{
            display: this.state.btnHide
          }}
          className="ImgButtonR"
          onClick={() => {
            localStorage.setItem(
              "numbers",
              JSON.stringify(this.state.bingoValues)
            );
            
          this.setState({btnHide: 'none',mark: 'block'})
          console.log(this.state.mark)
          }}
        >
        </Image>
        <h1 style={localStorage.numbers ? { display: 'block' } : { display: 'none' }}>✔</h1>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Bingo.jsx